/**
 * School branding constants — used across login, sidebar, receipts, payslips, PDFs.
 */
import logoUrl from "@/assets/lfs-logo.jpeg";

export const SCHOOL = {
  name: "Little Flowers School",
  shortName: "LFS",
  tagline: "Motivada, Udvada, Valsad",
  address: "Little Flowers School, Udvada, Motiwada Rd, Kikarla, Gujarat 396185",
  addressShort: "Udvada, Motiwada Rd, Kikarla, Gujarat 396185",
  phone: "+91 09574477011",
  website: "www.lfschool.in",
  email: "info@lfschool.in",
  logo: logoUrl as string,
  // primary brand colour (green, matching the wreath)
  brandColour: "#2f7d34",
} as const;
